const ThumbsUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.66683 14.6668V7.3335M1.3335 8.66683V13.3335C1.3335 14.0699 1.93045 14.6668 2.66683 14.6668H11.6177C12.6048 14.6668 13.4443 13.9466 13.5944 12.9709L14.3124 8.30428C14.4987 7.09276 13.5614 6.00016 12.3356 6.00016H10.0002C9.63197 6.00016 9.3335 5.70169 9.3335 5.3335V2.97739C9.3335 2.06949 8.5975 1.3335 7.6896 1.3335C7.47305 1.3335 7.27682 1.46103 7.18887 1.65891L4.84279 6.93759C4.73579 7.17834 4.49704 7.3335 4.23358 7.3335H2.66683C1.93045 7.3335 1.3335 7.93045 1.3335 8.66683Z"
      stroke="#535862"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ThumbsUp;
